export const environment = {
  production: process.env.NODE_ENV === 'production',
  development: process.env.NODE_ENV === 'development',
  test: process.env.NODE_ENV === 'test',
  
  // MindBody Authentication
  auth: {
    mindBodyApiKey: process.env.REACT_APP_MINDBODY_API_KEY || '',
    defaultSiteId: process.env.REACT_APP_MINDBODY_DEFAULT_SITE_ID ? 
      parseInt(process.env.REACT_APP_MINDBODY_DEFAULT_SITE_ID, 10) : 0,
  },
  
  // API Configuration
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://cueflow-api.azurewebsites.net/api',
    version: process.env.REACT_APP_API_VERSION || 'v1',
  },
  
  // Application Settings
  app: {
    environment: process.env.REACT_APP_ENVIRONMENT || 'development',
    version: process.env.REACT_APP_VERSION || '0.0.0',
  },
  
  // Feature Flags
  features: {
    analytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
    sentry: process.env.REACT_APP_ENABLE_SENTRY === 'true',
  },
  
  // Azure Storage
  storage: {
    account: process.env.REACT_APP_STORAGE_ACCOUNT || '',
    container: process.env.REACT_APP_STORAGE_CONTAINER || '',
  },
  
  // Application Insights
  monitoring: {
    appInsightsKey: process.env.REACT_APP_APPINSIGHTS_KEY || '',
  },
};

// Type for environment configuration
export type Environment = typeof environment;